import React from "react";
import { observer } from "mobx-react-lite";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { TuvisMessagingPhone } from "@whatslly/types/tuvis-messaging/TuvisMessagingPhones";
import styles from "./ChatFromModal.module.scss";
import { useTranslation } from "react-i18next";
import { getPhoneName, getPhoneNumber } from "@whatslly/ui-components/Pages/TuvisMessaging/SelectContactModal/selectContactModalUtils";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";
export const CHANNEL_ICONS: Record<TuvisMessagingPhone["type"], TuvisIconNamesType> = {
  whatsapp: "whatsapp-logo",
  twilio: "chat-now",
  imessage: "imessage-logo",
};

interface ChatFromModalProps extends IModalInstance<{ phone: TuvisMessagingPhone }> {
  phones: TuvisMessagingPhone[];
}

export const ChatFromModal: React.FC<ChatFromModalProps> = observer(({ closeModal, phones }) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      backdropClassName={styles.backdrop}
      className={styles.modal}
      closeModal={closeModal}
      closeOnClickOutside={false}
      closeOnEscape={false}
      headerClassName={styles.header}
      header={<ModalHeader closeModal={closeModal}>{t("whatsapp_business_api_agent_page.chat_from_dialog.title")}</ModalHeader>}
    >
      {phones.map((phone, index) => {
        return (
          <div key={phone.id} className={index !== phones.length - 1 ? styles.container : undefined}>
            <div onClick={() => closeModal({ phone })}>
              <div className={styles.rippleViewContainer}>
                <SvgV2 iconName={CHANNEL_ICONS[phone.type]} width={20} height={20} />
                <div>
                  <div>{getPhoneName(phone)}</div>
                  <div>{getPhoneNumber(phone)}</div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </BaseModal>
  );
});
